import "./index.scss";

import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";

import App from "./App";
import {
  setDropdownMenuTitle,
  setModalCancelLabel,
  useThemeStore,
} from "./covaltech-react-ui";
import i18n from "./i18n/i18n";
import { useAuthStore } from "./stores/AuthStore";
import { useVolunteerAuthStore } from "./stores/VolunteerAuthStore";

useThemeStore.getState().init();

// Localize the covaltech Modal's built-in cancel button through i18n, and keep
// it in sync when the active language changes.
const syncModalCancelLabel = () => setModalCancelLabel(i18n.t("common.cancel"));
syncModalCancelLabel();
i18n.on("languageChanged", syncModalCancelLabel);

// Same for the covaltech StyledDropdown's menu title ("Choose <label>"),
// which would otherwise read half English in French.
const syncDropdownMenuTitle = () =>
  setDropdownMenuTitle((label) =>
    i18n.t("common.dropdown_menu_title", { label: label.toLowerCase() }),
  );
syncDropdownMenuTitle();
i18n.on("languageChanged", syncDropdownMenuTitle);

// Revalidate both auth sessions against their httpOnly cookies (fire-and-forget;
// each store updates when its /me resolves).
void useAuthStore.getState().hydrate();
void useVolunteerAuthStore.getState().hydrate();

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
);
